import { useParseRouteActions } from "../../../helpers/GlobalHelper";
import LmsTable from "../ui/LmsTable";

const LmsAccountingPurchasingCompanyInterest = ({ params = {}, history }) => {
  const { isActionAllowed } = useParseRouteActions(params);
  if (!isActionAllowed) {
    history.goBack();
  }

  return <LmsTable 
    actionButtons={["export"]} 
    apiSuffix="/payment/puchasing-company-interests" 
    columnLabelsDictionary={{
      loanNumber: "Loan #"
    }}
    skipClick
    useApiFiltering
  />;
};

export default LmsAccountingPurchasingCompanyInterest;
